<dashboardnav>
  <cradua-damage-status [damagestatuss]="damagestatuss$ | async" (damagestatus)="onSubmitDamageStatus($event)"
    (deleteDamageStatusEvent)="onDeleteDamageStatus($event)" *ngIf="(isLoadingDamageStatus$ | async ) === false">
  </cradua-damage-status>

  <mrsoftapps-epims-reference-spinner *ngIf="(isLoadingDamageStatus$ | async) === true">
  </mrsoftapps-epims-reference-spinner>
  <!-- <pre>{{isLoading$ | async | json}}</pre> -->
</dashboardnav>
